import { Component, OnInit, Pipe, ViewChild, ElementRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { DashBoardService } from 'app/main/pages/dashboard/dashboard.services';
import { ChartOptions, ChartType, ChartDataset, ChartConfiguration } from 'chart.js';

import { takeUntil } from 'rxjs/operators';
import { DestroyableComponent } from 'app/main/destroyable.component';
import { makeDrawValuePlugin } from '../chartjs.plugins';

@Component({
    selector: 'reviews',
    templateUrl: './reviews.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReviewsComponent extends DestroyableComponent implements OnInit{
	public showLoader: boolean;

	public barChartOptions: ChartOptions<'line'> = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {},
			avg: {
				type: 'linear',
				position: 'left',
				max: 5,
				min: 0
			},
			percent: {
				type: 'linear',
				position: 'right',
				max: 100,
				min: 0
			}
		},
		plugins: {
			legend: {
				position: 'right',
				align: 'start',
				fullSize: true,
				labels: {
					usePointStyle: true,
					padding: 15
				}
			},
			tooltip: {
				cornerRadius: 8,
				padding: { top: 6, bottom: 6, left: 8, right: 8 },
				caretSize: 0,
				caretPadding: 10,
				backgroundColor: '#b5b5b5',
				displayColors: false,
				callbacks: {
					label: function(tooltipItem): string {
						const n = Number(tooltipItem.parsed.y);
						if(!n || isNaN(n)) return '';
						return n.toLocaleString('US');
					},
					title: function(items): string{
						return;
					},
				},
			},
		},
	};
	public chartPlugins = [makeDrawValuePlugin()];
	public barChartLabels: string[] = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
	public barChartType: ChartType = 'line';
	public barChartLegend = true;

	public reviews: ChartDataset[];
	public chartData: ChartConfiguration['data'];

	constructor(public dashboardService: DashBoardService){
		super();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void{
		this.dashboardService.reviewResponse
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: (response: any) => {
				this.onData(response);
			}
		});
	}

	public onData(response: any): void{
		this.showLoader = true;
		
		if(!response) return;
		else if (response.length) this.showLoader = false;

		const data: ChartDataset<'line', number[]>[] = [
			{
				data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				label: 'negative',
				yAxisID: 'percent',
				tension: 0,
				fill: false,
				backgroundColor: '#ff6384',
				hoverBackgroundColor: '#ff6384',
				borderColor: '#ff6384',
				hoverBorderColor: '#ff6384',
				pointBackgroundColor: '#ff6384',
				pointHoverBackgroundColor: '#ff6384',
				pointBorderColor: '#ff6384',
				pointHoverBorderColor: '#ff6384',
				pointRadius: 5
			},
			{
				data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				label: 'positive',
				yAxisID: 'avg',
				tension: 0,
				fill: false,
				backgroundColor: '#4bc0c0',
				hoverBackgroundColor: '#4bc0c0',
				borderColor: '#4bc0c0',
				hoverBorderColor: '#4bc0c0',
				pointBackgroundColor: '#4bc0c0',
				pointHoverBackgroundColor: '#4bc0c0',
				pointBorderColor: '#4bc0c0',
				pointHoverBorderColor: '#4bc0c0',
				pointRadius: 5
			}
		];

		if(response.length > 0){
			const monthCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
			const monthTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
			for (const item of response) {
				const monthIndex = Number(item.month) - 1;
				monthCount[monthIndex]++;
				monthTotal[monthIndex] += item.total;
				data[1].data[monthIndex] = Number(item.avg_points) + Number(data[1].data[monthIndex]);
				data[0].data[monthIndex] += item.negative_points;
			}

			for (let index = 0; index < 12; index++) {
				const avg = Number(data[1].data[index]);
				const negPoints = Number(data[0].data[index]);
				data[1].data[index] =  Math.round((avg / monthCount[index]) * 100) / 100;
				data[0].data[index] =  Math.round((negPoints / monthTotal[index]) * 10000) / 100;
			}
		}
		this.reviews = data;
		this.chartData = { labels: this.barChartLabels, datasets: data };
	}
	// -----------------------------------------------------------------------------------------------------
}
